//文件系统打包下载
window.filesystemDownload = json => {
    let form = $("<form>");
    form.attr('style', 'display:none');
    form.attr('target', '');
    form.attr('method', 'post');
    form.attr('action', window.systemParameter.FILE_SYSTEM_DOWNLOAD_URL + "/file/packdownload/");
    json.map(i => {
      let input = $('<input>');
      input.attr('type', 'hidden');
      input.attr('name', Object.keys(i)[0]);
      if (i[Object.keys(i)[0]].match(/[\u4e00-\u9fa5]+/g)) {
        input.attr('value', encodeURIComponent(i[Object.keys(i)[0]]));
      } else {
        input.attr('value', i[Object.keys(i)[0]]);
      }
      form.append(input);
    })
    $('body').append(form);
    form.submit();
  }

  //文件系统单文件下载
  window.filesystemSingleDownload = json => {
    let form = $("<form>");
    form.attr('style', 'display:none');
    form.attr('target', '');
    form.attr('method', 'get');
    form.attr('action', window.systemParameter.FILE_SYSTEM_URL + "/file/download/" + json[0].id);
    if (json[1] && json[1].filename) {
      let input = $('<input>');
      input.attr('type', 'hidden');
      input.attr('name', 'filename');
      if (json[1].filename.match(/[\u4e00-\u9fa5]+/g)) {
        input.attr('value', encodeURIComponent(json[1].filename));
      } else {
        input.attr('value', json[1].filename);
      }
      form.append(input);
    }
    $('body').append(form);
    form.submit();
  }
  //获取token
  window.getLocalStorage = function(name){
    let storage = Vue.prototype.getCookie("accesstoken");
    let arr = JSON.parse(storage)
    if(arr.hasOwnProperty(name)){
      return arr[name]
    }else{
      return null
    }
  }

//图片加载失败 设置默认替换图片
import default_avatar_url from './img/avatar.png'
import default_video_small from './img/img_video_small.png'
import default_image_small from './img/default_image_small.png'
Vue.prototype.errorImg = function (e, type) {
  // e.target.src=default_avatar_url;
  if (type) {
    switch (type) {
      case 'avatar':
        e.target.src = default_avatar_url;
        break;
      case 'video':
        e.target.src = default_video_small;
        break;
      case 'image':
        e.target.src = default_image_small;
        break;
      default:
        e.target.src = default_avatar_url;
        break;
    }
  }
}

//配置三四级面包屑
Vue.prototype.setBreadcrumb = function (arr) {
  if(arr) {
    appframe.$store.commit('setComBreadcrumbData', arr)
  }
}


// 只生成一层 a=b;c=d
window.eduFilterParam = function (obj) {
  let rs = []
  for (let ii in obj) {
    rs.push(ii + '=' + obj[ii])
  }
  return rs.join(';');
}


Vue.prototype.setCookie = function (name, value, time) {
  let Days = 30
  let exp = new Date()

  if(time){
    exp.setTime(exp.getTime()-10000)
  }else{
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  }
  // console.log('exp',exp)
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString()
}
Vue.prototype.getCookie = function (name) {
  var arr = [],
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)")
  if (arr = document.cookie.match(reg))
    return unescape(arr[2])
  else
    return null
}


//清除所有cookie
Vue.prototype.clearAllCookie = function () {
  let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if(keys) {
    for (let i = keys.length; i--;)
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
  }
}





Vue.prototype.logout = function () {
  //清除本地缓存重新登陆
  // localStorage.removeItem('accesstoken');
 

  if (isCas) {
    http.get('/webLogout').then((xhr) => {
      window.location.href = xhr.data.url;
    })
  } else {
    let localtoken = Vue.prototype.getCookie('accesstoken') ? JSON.parse(Vue.prototype.getCookie('accesstoken')) : '';
    if (localtoken && localtoken.access_token) {
      http.get('/gateway/auth/logout', {
        headers: { Authorization: 'Bearer ' + localtoken.access_token },
      }).then((xhr) => {
        appframe.$router.push('/signin')
      })
    } else {
      appframe.$router.push('/signin')
    }
  }

  localStorage.clear();
  Vue.prototype.clearAllCookie();
  window.status208 = true;
}


Vue.prototype.resetMenuMD = function(route,isHome){
  if (!route || !route.name) return;
  if (!isHome){
    _.each(appframe.$store.state.menuData, fir => {
      if (fir.component == route.name){
        appframe.$store.commit("setFocusFirMD", fir.name);
        appframe.$store.commit("setFocusSecMD", "");
        appframe.$store.commit("setCurrentSecMD", []);
        appframe.$store.commit("setFocusThiMD", "");
        appframe.$store.commit("setCurrentThiMD", []);
        appframe.$store.commit("setDefaultActiveId", fir.name + "_" + fir.id);
      }else{
        if (fir.sbmenus) {
          _.each(fir.sbmenus, sec => {
            if (sec.component == route.name){
              appframe.$store.commit("setFocusFirMD", fir.name);
              appframe.$store.commit("setFocusSecMD", sec.name);
              appframe.$store.commit("setCurrentSecMD", fir.sbmenus);
              appframe.$store.commit("setFocusThiMD", "");
              appframe.$store.commit("setCurrentThiMD", []);
              appframe.$store.commit("setDefaultActiveId", sec.name + "_" + sec.id);
            }else{
              if(sec.sbmenus){
                _.each(sec.sbmenus, thi=>{
                  if (thi.component == route.name){
                    appframe.$store.commit("setFocusFirMD", fir.name);
                    appframe.$store.commit("setFocusSecMD", sec.name);
                    appframe.$store.commit("setCurrentSecMD", fir.sbmenus);
                    appframe.$store.commit("setFocusThiMD", thi.name);
                    appframe.$store.commit("setCurrentThiMD", sec.sbmenus);
                    appframe.$store.commit("setDefaultActiveId", sec.name + "_" + sec.id);
                  }
                })
              }

            }
          });
        }
      }
    });
  }else{
    appframe.$store.commit("setFocusFirMD", '首页');
    appframe.$store.commit("setFocusSecMD", "");
    appframe.$store.commit("setCurrentSecMD", []);
    appframe.$store.commit("setFocusThiMD", "");
    appframe.$store.commit("setCurrentThiMD", []);
    appframe.$store.commit("setDefaultActiveId", '首页_000');
  }
  appframe.$irouter(route);
};







// WEBPACK FOOTER //
// ./src/common.js